import {
    combineReducers,
    configureStore,
    isRejectedWithValue,
    Middleware,
} from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query/react';
import Logger from '@/core/utils/logging';

import { rapidstorApi } from '../core/api/rapidstor';
import { bookingSlice } from './bookingSlice';

const reducer = combineReducers({
    [rapidstorApi.reducerPath]: rapidstorApi.reducer,
    [bookingSlice.name]: bookingSlice.reducer,
});

/**
 * Log a error to sentry
 */
export const rtkQueryErrorLogger: Middleware = () => (next) => (action) => {
    if (isRejectedWithValue(action)) {
        Logger.info('RTK Query Error', undefined, [
            {
                name: 'type',
                value: action.type,
            },
            {
                name: 'error',
                value: `${JSON.stringify(action.error)}`,
            },
            {
                name: 'meta',
                value: `${JSON.stringify(action.meta)}`,
            },
            {
                name: 'payload',
                value: `${JSON.stringify(action.payload)}`,
            },
        ]);
    }

    return next(action);
};

const store = configureStore({
    reducer,
    middleware: (getDefaultMiddleware) => getDefaultMiddleware()
        .concat(rapidstorApi.middleware)
        .concat(rtkQueryErrorLogger),
});

setupListeners(store.dispatch);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
